/* unplugin-vue-components disabled */import { render } from "./CardInteractive.vue?vue&type=template&id=4fca6046&scoped=true&ts=true"
import script from "./CardInteractive.vue?vue&type=script&lang=ts"
export * from "./CardInteractive.vue?vue&type=script&lang=ts"

import "./CardInteractive.vue?vue&type=style&index=0&id=4fca6046&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fca6046"]])

export default __exports__